/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useBusinessContextsQuery,
  useGetPrimaryBcQuery,
} from "~/generated/graphql";

type Props = {
  limit: number;
};

export function useBusinessContext({ limit }: Props) {
  const { data, loading, error } = useBusinessContextsQuery({
    variables: { limit, page: 0 },
  });

  const {
    data: primaryBusinessContextData,
    loading: isPrimaryBusinessContextLoading,
    error: primaryBusinessContextError,
  } = useGetPrimaryBcQuery();

  const businessContexts = data?.businessContexts?.businessContexts;
  const primaryBusinessContextId =
    primaryBusinessContextData?.primaryBusinessContext?.id ?? "";

  const isLoading = isPrimaryBusinessContextLoading || loading;
  const errors = primaryBusinessContextError || error;

  return {
    businessContexts,
    primaryBusinessContextId,
    loading: isLoading,
    error: errors,
  } as const;
}
